<template>
  <v-dialog v-model="dialog" :max-width="options.width" @keydown.esc="cancel">
    <v-card>
      <v-card-title class="title grey lighten-2" primary-title>
        {{ title }}
      </v-card-title>

      <v-card-text>

        <template>
          <v-file-input
              accept="image/*"
              label="File input"
              v-model="files"
          ></v-file-input>
          <v-btn color="primary" class="mb-2" elevation="0" @click.native="onUploadClick">UPLOAD</v-btn>
        </template>

        <v-container class="file-drop-area" ref="uploadTarget"
                     v-on:dragover="onDragOver" v-on:dragenter="onDragEnter" v-on:dragleave="onDragLeave" v-on:drop="onDrop">

          <v-row>
            <v-col>
              画像ファイルをドロップしてください
            </v-col>
          </v-row>

        </v-container>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <!--<v-btn color="primary" elevation="0" @click.native="agree">はい</v-btn>-->
        <v-btn color="normal" elevation="0" @click.native="cancel">キャンセル</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>
<script>
import BaseDialog from "@/components/dialogs/BaseDialog";
import FileAssetAPI from "@/apis/FileAssetAPI";

export default {
  mixins:[BaseDialog],
  components: {},
  props: [],
  data() {
    return {
      files:null,
      uploading:false,
    };
  },
  methods: {


    onUploadClick(){
      if (!this.files){
        this.showErrorToast("ファイルが選択されていません。")
      } else {
        this.uploadFiles(this.files)
      }
    },

    // --------------------------------------
    // ファイルのドロップ処理
    // --------------------------------------
    findTargetElement(){
      return this.$refs.uploadTarget;
    },

    onDrop(e){
      e.preventDefault();
      e.stopPropagation();

      let elm = this.findTargetElement();
      elm.classList.remove('filehover');


      //console.log("onDrop ");

      let files = e.dataTransfer.files;
      //console.log(files);
      //this.processFiles(files);

      this.uploadFiles(files);
    },

    onDragOver(e){
      e.preventDefault();
      let elm = this.findTargetElement();
      elm.classList.add('filehover');
    },

    onDragEnter(e){
      e.preventDefault();
    },

    onDragLeave(e){
      e.preventDefault();
      let elm = this.findTargetElement();
      elm.classList.remove('filehover');
    },


    // --------------------------------------
    // ファイルのアップロード処理
    // --------------------------------------

    uploadFiles(files){

      let self = this;

      let targetFiles = [];

      if (files){
        if (files instanceof FileList){
          for (let i=0; i<files.length; i++) {
            let file = files[i];
            targetFiles.push(file);
          }
        } else {
          targetFiles.push(files);
        }
      } else return;

      targetFiles = targetFiles.filter(file => {
        return file.type === "image/png" || file.type === "image/jpeg";
      });

      let progressFunc = function(progress){
        console.log("uploadFile progress:" + progress);
      };

      if (targetFiles.length > 0){

        window.logger.log(targetFiles)

        this.uploading = true

        let file = targetFiles[0];

        FileAssetAPI.provisionalUpload(file,{},progressFunc)
            .then(a => {

              let fileId = a.fileId;
              window.logger.info("fileId = " + fileId)

              this.resolve([fileId]);

              self.dialog = false;

            })
            .catch(function(err) {
              console.log(err);
              self.showErrorToast("データの更新に失敗しました。");
            })
            .finally(()=>{
              self.uploading = false
            })

      }

    },


  },

}
/*
// 呼び出し方法
// https://qiita.com/ta1nakamura/items/f844dd2437af8ecc5674
async onClickOpen(){
  console.log('--onClickOpen')
  if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
    console.log('--yes')
  }else{
    console.log('--no')
  }
}
* */
</script>
